import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_SUPPLY_CHAIN: TypedDocumentNode<Data, { input: Variables }> = gql`
  mutation createSupplyChain($input: CreateSupplyChainInput!) {
    createSupplyChain(input: $input) {
      supplyChain {
        id
        name
      }
      errors {
        attribute
        message
      }
    }
  }
`
